import logo from "../img/blue-logo.webp";

const Logo = () => {
	return <img src={logo} alt="logo" />;
};
export default Logo;
